import { SET_API_SOURCE_FORM_MODAL_OPEN_STATUS } from '../actionTypes';
import { actions } from '../reducer';

export default (value) => actions[SET_API_SOURCE_FORM_MODAL_OPEN_STATUS](value);
